import React, { useCallback, useEffect, useRef, useState } from 'react'
import { css } from "@emotion/react";

import { NOOP } from "core/constants";
import useElementDimensions from "core/hooks/useElementDimensions";
import { useScript } from "core/hooks/useScript";
import { GOOGLE_APP_ID } from "core/config/config";
import theme from "theme/index";
import window from 'core/includes/window';

type Props = {
    handleLoginFailure: (error: any) => void,
    triggerLogin: (socialUser: any) => void,
    isSignUp: boolean,
}

const SocialButton: React.FC<Props> = ({ isSignUp = false, triggerLogin = NOOP, handleLoginFailure = NOOP }) => {
    const [random, setRandom] = useState(Math.random());
    const buttonRef = useRef<HTMLDivElement>(null);
    const buttonContainerRef = useRef<HTMLDivElement>(null);
    const buttonDimensions = useElementDimensions(buttonContainerRef.current);

    // Reload Google button every time the container dimensions change
    useEffect(() => {
        setRandom(Math.random());
    }, [buttonDimensions.width]);

    useScript("https://accounts.google.com/gsi/client", () => {
        window.google?.accounts?.id?.initialize({
            client_id: GOOGLE_APP_ID,
            callback: handleGoogleLogin,
            use_fedcm_for_prompt: true, // for testing FedCM (This will be ignored on 30-Jun-2025: Be used by force.)
        });
        window.google?.accounts?.id?.renderButton(buttonRef.current, {
            width: `${Math.round(buttonDimensions.width)}`,
            type: "text",
            shape: "circle",
            text: `${isSignUp ? 'signup_with' : 'continue_with'}`,
            size: "large",
            onsuccess: triggerLogin,
            onfailure: handleLoginFailure
        });
        window.google?.accounts?.id?.prompt(); // One Tap login
    }, random + 1);

    const handleGoogleLogin = useCallback((socialUser: any) => {
        try {
            triggerLogin(socialUser);
        } catch (e) {
            console.log(`e-->`, e);
            handleLoginFailure(e);
        }

    }, [triggerLogin, handleLoginFailure]);

    const socialLoginBlock = css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-direction: column;

        > div {
            margin-bottom: 21px;
        }

        ${theme.breakpoints.only("md")} {
            margin-top: 17px;
        }

        ${theme.breakpoints.down("xs")} {
            > div {
                margin-bottom: 20px;
            }
        }
    `;

    return (
        <div css={socialLoginBlock} ref={buttonContainerRef}>
            <div
                id={GOOGLE_APP_ID!}
                ref={buttonRef}
            />
        </div>
    );
}

export default SocialButton;
